
const priorityColorMap = {
  SMS: '#FDB15F',
  Calls: '#A79ECF',
  WhatsApp: '#49C4A2',
  Email: '#015258'
};
const ChannelByTypeChart = (data = [
  { label: 'Webinar', count: 12 },
  { label: 'Concert', count: 6 },
  { label: 'Meetup', count: 9 }
]) => {
  const safeData = Array.isArray(data) ? data : [];
  const totalTasks = safeData.reduce((sum, item) => sum + (item.count || 0), 0);

  return {
    title: {
      text: `${totalTasks}`,
      subtext: 'Total',
      left: '49%',
      top: '45%',
      textAlign: 'center',
      textVerticalAlign: 'middle',
      textStyle: {
        fontSize: 14,
        fontWeight: 'bold',
        fontFamily: 'Inter, Poppins, sans-serif',
        color: '#333'
      },
      subtextStyle: {
        fontSize: 14,
        color: '#888',
        fontFamily: 'Inter, Poppins, sans-serif'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: params => {
        const { name, value, percent } = params;
        return `<b>${name}</b><br/>🎟️ Count: ${value}<br/>📊 Percent: ${percent}%`;
      }
    },
    legend: {
      show: false
    },
    series: [
      {
        name: 'Event Type',
        type: 'pie',
        radius: ['35%', '65%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 6,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: true,
          position: 'outside',
          // 👇 Moves percent below the name & count
          formatter: params => {
            return `${params.name}: ${params.value}\n(${params.percent}%)`;
          },
          fontSize: 12,
          fontFamily: 'Inter, Poppins, sans-serif',
          lineHeight: 16,
          color: '#444'
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10,
          lineStyle: {
            color: '#aaa'
          }
        },
        data: safeData.map(item => ({
          name: item.label,
          value: item.count,
          itemStyle: { color: priorityColorMap[item.label] || '#ccc' }
        }))
      }
    ]
  };
};

export default ChannelByTypeChart;
